export default __webpack_public_path__ + "static/media/2.e5a0e307.jpg";